export default function formatCurrency(value: string) {
  return Number(value).toFixed(2).replace(".", ",");
}
